"use strict";function bindMeetingRoom$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.bindMeetingRoom$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.iot.bindMeetingRoom";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.34"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.34"},_a)),exports.bindMeetingRoom$=bindMeetingRoom$,exports.default=bindMeetingRoom$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/iot/bindMeetingRoom.js
// module id = 956
// module chunks = 106